import { audit, auditForInitial, get, getByBillNumber, getForRtn, getNtcByBillNumber, modify, query, queryConsumingAbleStock, remove, save, saveAndAudit, genInitialConsumBill } from '@/services/internal/Consuming';
import { page } from '@/services/internal/ConsumingNtc';
import { formatMessage } from 'umi/locale';
export default {
  namespace: 'consuming',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/inner/consuming") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    entity: {},
    showPage: 'query',
    ntcBill: [],
    ntcItems: {}
  },
  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);

      if (response && response.success) {
        yield put({
          type: 'save',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
    },

    *queryConsumingArticles({ payload, callback }, { call, put }) {
      const response = yield call(queryConsumingAbleStock, payload);
      if (response && response.success) {

        //商品去重
        let data = Array.isArray(response.data.records) ? response.data.records : [];
        let stocks = [...data];
        let obj = {};
        data = data.reduce((cur, next) => {
          next.article.spec = next.spec;
          obj[next.article.uuid] ? "" : obj[next.article.uuid] = true && cur.push(next.article);
          return cur;
        }, [])//设置cur默认类型为数组，并且初始值为空的数组
        yield put({
          type: 'onQueryBatchAddStocks',
          payload: {
            data: data,
            stocks: stocks
          },
        });
        if (callback) callback(stocks)
      }
    },

    *queryBatchAddStocks({ payload }, { call, put }) {
      const response = yield call(queryConsumingAbleStock, payload);
      if (response && response.success) {
        yield put({
          type: 'onQueryBatchAddStocks',
          payload: {
            list: response.data && response.data.records ? response.data.records : [],
            pagination: {
              total: response.data ? response.data.paging.recordCount : 0,
              pageSize: response.data ? response.data.paging.pageSize : 0,
              current: response.data ? response.data.page + 1 : 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
    },

    *queryNtcpage({ payload, callback }, { call, put }) {
      const response = yield call(page, payload);

      if (response && response.success) {
        yield put({
          type: 'saveNtc',
          payload: {
            ntcBill: response.data.records ? response.data.records : []
          },
        });
      }
    },

    *getNtcByBillNumber({ payload, callback }, { call, put }) {
      const response = yield call(getNtcByBillNumber, payload);
      yield put({
        type: 'ntcItems',
        payload: response.data ? response.data : {}
      });
      if (callback) callback(response);
    },

    *onSave({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: response.data
        });
      }
      if (callback) callback(response);
    },

    *onModify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: payload.uuid
        });
      }
      if (callback) callback(response);
    },

    *onRemove({ payload, callback }, { call, put }) {
      const response = yield call(remove, payload);
      if (callback) callback(response);
    },

    *onSaveAndAudit({ payload, callback }, { call, put }) {
      const response = yield call(saveAndAudit, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: response.data
        });
      }
      if (callback) callback(response);
    },

    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      yield put({
        type: 'onView',
        payload: response.data ? response.data : {}
      });
      if (callback) callback(response);
    },
    *getForRtn({ payload, callback }, { call, put }) {
      const response = yield call(getForRtn, payload);
      yield put({
        type: 'onView',
        payload: response.data ? response.data : {}
      });
      if (callback) callback(response);
    },

    *getByBillNumber({ payload, callback }, { call, put }) {
      const response = yield call(getByBillNumber, payload);
      yield put({
        type: 'onView',
        payload: response.data ? response.data : {}
      });
      if (callback) callback(response);
    },

    *onAudit({ payload, callback }, { call, put }) {
      const response = yield call(audit, payload);
      if (callback) callback(response);
    },

    *onAuditForInitial({ payload, callback }, { call, put }) {
      const response = yield call(auditForInitial, payload);
      if (callback) callback(response);
    },

    *genInitialConsumBill({ payload, callback }, { call, put }) {
      const response = yield call(genInitialConsumBill, payload);
      yield put({
        type: 'onView',
        payload: response.data ? response.data : {}
      });
      if (callback) callback(response);
    },

    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
        billNumber: payload.billNumber,
        consumingNtcBillNumber: payload.consumingNtcBillNumber,
        ntcSkip: payload.ntcSkip
      });
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    clear(state, action) {
      return {
        ...state,
        ntcBill: [],
      };
    },
    saveNtc(state, action) {
      return {
        ...state,
        ntcBill: action.payload.ntcBill,
      };
    },
    ntcItems(state, action) {
      return {
        ...state,
        ntcItems: action.payload,
      };
    },
    onView(state, action) {
      return {
        ...state,
        entity: action.payload,
        entityUuid: action.entityUuid,
        billNumber: action.billNumber
      }
    },
    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid,
        billNumber: action.billNumber,
        consumingNtcBillNumber: action.consumingNtcBillNumber,
        ntcSkip: action.ntcSkip
      }
    },
    onQueryBatchAddStocks(state, action) {
      return {
        ...state,
        stockList: action.payload
      }
    },
  },
}
